// Array of representatives and their respective states
var representatives = [
  {
    name: "Danielle Washington",
    phone: "800-882-7779, Option 1",
    fax: "630-354-1277",
    email: "Danielle.Washington@avispl.com",
    states: [
      "Illinois",
      "Michigan",
      "Minnesota",
      "Wisconsin"
    ]
  },

  {
    name: "Jimmy Gentry",
    phone: "800-882-7779, Option 1",
    fax: "913-535-5328",
    email: "Jimmy.Gentry@avispl.com",
    states: [
      "Alabama",
      "California",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Indiana",
      "Kentucky",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Mississippi",
      "New Hampshire",
      "New Jersey",
      "New York",
      "North Carolina",
      "Ohio",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "Tennessee",
      "Vermont",
      "Virginia",
      "West Virginia"
    ]
  },

  {
    name: "Philip Benibo",
    phone: "800-882-7779, Option 1",
    fax: "913-535-5335",
    email: "Philip .Benibo@avispl.com",
    states: [
      "Alaska",
      "Arizona",
      "Arkansas",
      "Colorado",
      "Hawaii",
      "Idaho",
      "Iowa",
      "Kansas",
      "Louisiana",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Mexico",
      "North Dakota",
      "Oklahoma",
      "Oregon",
      "South Dakota",
      "Texas",
      "Utah",
      "Washington",
      "Wyoming"
    ]
  }
  // Add more representative objects with their respective states
];

function findRepresentative(state) {
  for (var i = 0; i < representatives.length; i++) {
    if (representatives[i].states.includes(state)) {
      return representatives[i];
    }
  }
  return null; // Return null if a representative is not found for the state
}

$("select").on("change", function () {
  var state = $(this).val();
  var representative = findRepresentative(state);

  if (representative) {
    $("#representativeName").text(representative.name);
    $("#phone").text("Phone #: " + representative.phone);
    $("#email").html("<a href='mailto:" + representative.email + "?subject=Headset Inquiry from " + state  + "' class='headset-email'>Email " + representative.name + "</a>");
    $("#infoContainer").show();
  } else {
    $("#infoContainer").hide(); // Hide the container if a representative is not found for the state
  }
});
